module.exports = __webpack_public_path__ + "img/arrow-right.c75f5d39.svg";